import React, { useContext } from 'react'
import { Card } from 'react-bootstrap'
import gql from 'graphql-tag'
import { get } from 'lodash'
import { Link, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlusCircle, faSpinner} from '@fortawesome/free-solid-svg-icons'
import routes from '../routes'
import {AppNavContext} from './App'
import queryString from 'query-string'
import memoize from 'memoize-one'
import ChildListTable from './item/ChildListTable'
import '../styles/item/Item.css'

const DEFAULT_MAX = 10

const GET_COMMUNITIES_ITEM = gql`
  query GetItem($id: ID!, $max: Int, $offset: Int, $sort: SortColumn, $order: SortDirection) {
    item(id: $id) {
      id
      permissions {
        currentUser {
          canWrite
        }
      }
      childItems(max: $max, offset: $offset, sort: $sort, order: $order) {
        items {
          id
          title
          parentId
          linkParentIds
          hasChildren
          fileConnection {
            totalCount
          }
          provenance {
            lastUpdated
            dateCreated
          }
          spatial {
            boundingBox {
              maxX
            }
          }
          facets {
            facetName
          }
          systemTypes
          permissions {
            currentUser {
              canWrite
            } 
          }
        }
        totalCount
      }
      
    }
  }
`

export default function HomeCardCommunities() {
  const appNav = useContext(AppNavContext)
  const id = get(appNav, 'majorFolders.communities.id')
  const location = useLocation()
  const search = queryString.parse(location.search)

  const genQueryVariables = memoize((id) => {
    const sort = search.sort ? search.sort : 'title'

    return {
      id,
      max: parseInt(search.max) || DEFAULT_MAX,
      offset: (search.page - 1 || 0) * (search.max || DEFAULT_MAX),
      sort: sort,
      order: search.order,
    }
  })

  const {loading, error, data} = useQuery(GET_COMMUNITIES_ITEM, {
    // notifyOnNetworkStatusChange: true,
    variables: genQueryVariables(id),
    fetchPolicy: 'cache-and-network'
  })

  const item = get(data, 'item', {})
  const childItems = get(item, 'childItems', {})
  const itemId = item && item.id
  const canWrite =  get(item, 'permissions.currentUser.canWrite', false)

  return (
    <div className={'' + (loading ? 'sb-item-border-loading' : 'sb-item-border')}>
      <div className={error ? 'alert alert-danger' : 'd-none'} role='alert'>
        An error occurred while loading the community folders list.
      </div>

      <div>
        <Card bg="light">
          <Card.Header as="h4">
            <Link to={`${routes.itemPath}/${id}`}>Community Folders</Link>
            { canWrite ?
              <Link to={`${routes.itemPath}/${itemId}/new`}><FontAwesomeIcon icon={faPlusCircle} fixedWidth /></Link>
              : ''
            }
            { loading ? <FontAwesomeIcon icon={faSpinner} spin fixedWidth /> : '' }
          </Card.Header>
          <Card.Body>
            <ChildListTable
              location={ location }
              childItems={ childItems }
              queryVariables={ genQueryVariables(id) }
            />
          </Card.Body>
        </Card>

      </div>
    </div>
  )
}